<template>
  <div>
    <v-menu
        open-on-hover
        top
        offset-y
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
            small
            fab
            text
            v-bind="attrs"
            v-on="on"
        >
          <img :src="selected && require(`@/assets/flags/`+selected.locale+`.png`)"/>
        </v-btn>
      </template>

      <v-list>
        <v-list-item
            v-for="(item, index) in items"
            :key="index"
            class="pointer"
            @click="changeTo(item)"
        >
          <v-list-item-avatar tile size="16"><v-img :src="require(`@/assets/flags/`+item.locale+'.png')"/></v-list-item-avatar>
          <v-list-item-action >{{ item.name }}</v-list-item-action>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: "LanguageSwitcher",
  data: () => ({
    selected: {
      locale: 'ru'
    },
    items: [
      {
        name: 'Русский',
        locale: 'ru'
      },
      {
        name: 'English',
        locale: 'en'
      },
    ],
  }),
  mounted() {
    let currentFlag = this.items.find(item=>item.locale === this.$i18n.locale)
    if(currentFlag){
      this.selected = currentFlag;
    }
  },
  methods:{
    changeTo(to){
      this.$i18n.locale = to.locale;
      this.selected = to;

      this.$router.push({ name: this.$route.name, query:{lang:to.locale} })
    }
  }
}
</script>

<style scoped>

</style>